// import { Component, OnInit } from '@angular/core';
// import { AppService } from 'src/app/app.service';
// import { DatePipe } from '@angular/common';
// @Component({
//   selector: 'app-purchasereport',
//   templateUrl: './purchasereport.component.html',
//   styleUrls: ['./purchasereport.component.scss']
// })
// export class PurchasereportComponent implements OnInit {

//   To: any;
//   From: any;
//   Module_Row: any;
//   public rows = [];
//   public add: any = {};
//   public addValidation: boolean = false;
// public totalAmount: number = 0;
//   constructor(public appservice: AppService,public datePipe: DatePipe) { 
//     // this.appservice.get_S_Deal_Report();
//    // this.appservice.get_purchaseReport();
   
//    this.From = this.datePipe.transform(new Date(), "yyyy-MM-dd");
//    this.To = this.datePipe.transform(new Date(), "yyyy-MM-dd");
//   }
 
// // public Summary_rows=[
// //  { Field: 'pl_ProdName', Name: 'Product Name', Align: '' },
 
// //  { Field: 'pl_Brand', Name: 'Brand', Align: '' },
// //  { Field: 'pl_PackingQty', Name: 'Qty', Align: '' },
// //  { Field: 'pl_UOM', Name: 'Uom', Align: '' },
// //  { Field: 'pl_InwardLoc', Name: 'QA Location', Align: '' },
// //  { Field: 'pl_MFGMachine', Name: 'Machine No', Align: '' },
   

// //   ]; 
  
//   ngOnInit(): void {
//   }
//    Back() {
//     this.appservice.back();
//   }
//   public Purchase_report_Row = [];
//   get_purchaseReport() {
//   this.appservice.get(`Api/transaction/get_purchaseReport?From=${this.From}&To=${this.To}`)
//     .subscribe((res: any) => {   
//       if (res && res !== '') {
//         const parsed = JSON.parse(res);
//         this.Purchase_report_Row = parsed.record || [];

//         // Calculate total amount
//         this.totalAmount = this.Purchase_report_Row.reduce((sum, row) => {
//           const total = parseFloat(row['Total']) || 0;
//           return sum + total;
//         }, 0);

//         console.log("the records are ", this.Purchase_report_Row[0]);
//         console.log("Total Amount:", this.totalAmount);
//       }
//       else {
//         this.Purchase_report_Row = [];
//         this.totalAmount = 0;
//         alert("No Data Found");  
//       }
//     });
// }
// //   get_purchaseReport() {
// //   //this.isload = true;
// //   this.appservice.get("Api/transaction/get_purchaseReport?From=" + this.From + "&To=" + this.To)
// //     .subscribe((res: any) => {   
// //       //this.isload = false;
// //       if(res!=""){
// // this.Purchase_report_Row = JSON.parse(res).record;
// //       console.log("the records are ",this.Purchase_report_Row[0]);
// //       }
// //       else{alert("No Data Found");  }
// //     }); 
// //     console.log("the records are 1",this.Purchase_report_Row[0]);
// // }

//   display() {
//     debugger
//    // var deal = this.add.tb_DealName;
//     this.get_purchaseReport();
//   }
//   export_excel()
//   {
//   //  this.appservice.Timesheet_Entry_Export =  this.appservice.get_fields_of('Customer_Details');

//    //this.appservice.Excel_Data.Header=this.Summary_rows;
//    this.appservice.Excel_Data.items=this.appservice.SummaryReport_Row;
//    this.appservice.Excel_Data.Report_Name="SummaryReport";
//    this.appservice.Excel_Data.FileName="SummaryReport";
//    this.appservice.export_excel();
 
//   }

// }
import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-purchasereport',
  templateUrl: './purchasereport.component.html',
  styleUrls: ['./purchasereport.component.scss']
})
export class PurchasereportComponent implements OnInit {

  From: string;
  To: string;
  public Purchase_report_Row: any[] = [];
  public totalAmount: number = 0;

  constructor(public appservice: AppService, public datePipe: DatePipe) { 
    this.From = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;
    this.To = this.datePipe.transform(new Date(), "yyyy-MM-dd")!;
  }

  ngOnInit(): void {}

  display() {
    this.get_purchaseReport();
  }

  get_purchaseReport() {
    this.appservice.get(`Api/transaction/get_purchaseReport?From=${this.From}&To=${this.To}`)
      .subscribe((res: any) => {   
        if (res && res !== '') {
          const parsed = typeof res === 'string' ? JSON.parse(res) : res;
          this.Purchase_report_Row = Array.isArray(parsed) ? parsed : parsed?.record || [];

          // Calculate total amount
          this.totalAmount = this.Purchase_report_Row.reduce((sum, row) => {
            const total = parseFloat(row['Total']) || 0;
            return sum + total;
          }, 0);

          console.log("Purchase Records:", this.Purchase_report_Row);
          console.log("Total Amount:", this.totalAmount);
        } else {
          this.Purchase_report_Row = [];
          this.totalAmount = 0;
          alert("No Data Found");  
        }
      }, error => {
        console.error("Error fetching purchase report:", error);
      });
  }

  export_excel() {
    const dataToExport = [...this.Purchase_report_Row];

    if (this.totalAmount > 0) {
      dataToExport.push({
        'Item Name': 'Total',
        'Total': this.totalAmount
      });
    }

    this.appservice.Excel_Data.items = dataToExport;
    this.appservice.Excel_Data.Report_Name = "PurchaseReport";
    this.appservice.Excel_Data.FileName = "PurchaseReport";
    this.appservice.export_excel();
  }

  Back() {
    this.appservice.back();
  }
}
